import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import {
  isPublicRoute,
  createAuthenticatedRequest,
} from '@core/utils/auth.utils';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip authentication for public routes
  if (isPublicRoute(req.url)) {
    return next(req);
  }

  const authenticationService = inject(AuthenticationService);

  // Handle different authentication types based on route
  const authenticatedRequest = createAuthenticatedRequest(
    req,
    authenticationService
  );

  return next(authenticatedRequest);
};
